import { CreateService, CRUDServiceInterface } from '@/services/service';
import APIBuilder from '@quangphuc/frontend-api-builder';
import { BulletinEntity } from '@/entities/bulletin.entity';

export default class BulletinService
  extends CreateService<BulletinEntity>('bulletin')
  implements CRUDServiceInterface<BulletinEntity>
{
  async getOne(
    id: number,
    join: string[] = ['staff', 'comments', 'reactions', 'reactions.emoticon'],
  ): Promise<BulletinEntity> {
    this.apiBuilder.reset()
    return super.getOne(id, join);
  }
  async upload(
    id: number,
    instance: { image: File; file: File },
  ): Promise<void> {
    if (!instance.image && !instance.file) return;
    const formData = new FormData();
    if (instance.image) {
      formData.append('image', instance.image);
    }
    if (instance.file) {
      formData.append('file', instance.file);
    }
    await APIBuilder.axios.patch<BulletinEntity>(
      `${this.apiBuilder.$endpoint}/upload/${id}`,
      formData,
    );
  }
}
